import { useState } from 'react';
import "./ProfileTabsv2.scss";
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import AccountDetailsv2 from '../AccountDetailsv2/AccountDetailsv2'
import ChangePasswordv2 from '../ChangePasswordv2/ChangePasswordv2'
import KYC from '../KYC';
import { withTranslation, useTranslation, Trans } from "react-i18next";
import useMediaQuery from "@material-ui/core/useMediaQuery";




function TabPanel(props) {
  const { children, value, index, ...other } = props;


  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  textCenter: {
    textAlign: "center",
    justifyContent: "center",
  }
}));

function ProfileTabsv2(props) {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const { t } = useTranslation();
  const minDesktop = useMediaQuery("(min-width: 992px)");



  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div id="ProfileTabsv2">
      <div className="prRoot px-3 ">
      {!minDesktop ? <div className="container-fluid py-3">
            <div className="row d-flex justify-content-center">
              <div className="col-sm-12 d-flex justify-content-between align-items-center">  <h5 className=""> <strong>{t("dashboard.my-profile")} </strong></h5> </div>
            </div>
          </div> : ""}
        <div className={classes.root}>
          <div className="profile_tabsv2">
            <AppBar position="static">
              <Tabs value={value} variant="fullWidth" className={classes.textCenter} onChange={handleChange} aria-label="simple tabs example">
                <Tab label={t("form.account-details")} {...a11yProps(0)} />
                {/* <Tab label={t("form.Change-Password")} {...a11yProps(1)} /> */}
                {/* <Tab label={t("form.kyc")} {...a11yProps(2)} /> */}
              </Tabs>
            </AppBar>
          </div>
          {/* Panel 1 */}

          <TabPanel value={value} index={0}>
            <AccountDetailsv2 />
          </TabPanel>

          {/* Panel 2 */}

          {/* <TabPanel value={value} index={1}>
            <ChangePasswordv2 />
          </TabPanel> */}

          {/* <TabPanel value={value} index={2}>
          <KYC />
        </TabPanel> */}
        </div>
      </div>
    </div>

  );
}

export default withTranslation()(ProfileTabsv2);
